import { render } from "./History.vue?vue&type=template&id=1362edc7&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=1362edc7&scoped=true&lang=css"

import exportComponent from "/Users/windy/work/vue/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1362edc7"]])

export default __exports__